module.exports = __webpack_public_path__ + "static/media/HN.7c298b8e.png";